<!--
 * @Author: baiwei
 * @Date: 2020-04-24 11:16:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-28 14:55:06
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <Modal v-model="show"
           :title="$t('配置权限')"
           @on-ok="submit"
           :loading="loading"
           :width="800">
        <Form ref="form"
              label-position="right"
              :model="formData"
              :label-width="100"
              :rules="validate"
              class="config-pack">
            <FormItem :label="$t('用户组')+'：'"
                      prop="userGroupIds"
                      style="padding-right: 50px;">
                <Select v-model="formData.userGroupIds"
                        multiple>
                    <Option v-for="item in groupList"
                            :value="item.groupSid"
                            :key="item.groupSid">{{ item.groupName }}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('权限')+'：'">
                <!-- <Transfer :data="policesList"
                          :target-keys="formData.policySids"
                          :titles="[$t('未选择'), $t('已选择')]"
                          filterable
                          :filter-method="userFilter"
                          @on-change="handleChange"
                          :render-format="transferRender"
                          :list-style="{width: '280px'}">
                </Transfer> -->
                <CustomTransfer :data="policesList"
                                :target-keys="formData.policySids"
                                @on-change="handleChange"></CustomTransfer>
            </FormItem>
        </Form>
    </Modal>
</template>
<script>
import CustomTransfer from './customtransfer'
import API from '@/service/api'
export default {
    name: 'configureusergrouppolices',
    components: {
        CustomTransfer
    },
    data () {
        return {
            show: false,
            loading: true,
            formData: {
                userGroupIds: [],
                policySids: [],
                userSids: []
            },
            groupList: [],
            policesList: [],
            validate: {
                userGroupIds: {
                    required: true,
                    validator: (rule, value, callback) => {
                        value.filter(item => item).length ? callback() : callback(new Error(this.$t('请选择')))
                    },
                    trigger: 'change'
                }
            }
        }
    },
    created () {
    },
    methods: {
        changeLoading () {
            this.loading = false
            this.$nextTick(() => {
                this.loading = true
            })
        },
        open (groupSid, policySids) {
            this.initData(groupSid)
            this.formData = {
                userGroupIds: [groupSid],
                policySids: [],
                userSids: []
            }
            this.show = true
        },
        initData (groupSid) {
            if (!groupSid) return
            this.axios.get(this.urlFormat(API.ACCESS_USERGROUP, false, [groupSid])).then(res => {
                this.formData = {
                    userGroupIds: [groupSid],
                    policySids: res.policies.map(user => `${user.policySid}`) || [],
                    userSids: res.subusers.map(user => String(user.userSid)) || []
                }
            })
            this.axios.get(this.urlFormat(API.ACCESS_POLICES, false)).then(res => {
                this.policesList = res.dataList.map(item => {
                    return {
                        key: item.policySid,
                        name: item.policyName,
                        description: item.displayName
                    }
                })
            })
            this.axios.get(this.urlFormat(API.ACCESS_USERGROUPS, false)).then(res => {
                this.groupList = res
            })
        },
        // userFilter(data, query) {
        //     return `${data.groupName} ${data.description || ''}`.includes(query)
        // },
        // transferRender(data) {
        //     return `<span>${data.policyName}</span><p>${data.displayName || ''}</p>`
        // },
        handleChange (newTargetKeys, direction, moveKeys) {
            this.formData.policySids = newTargetKeys || []
            // this.$refs.form.validateField('policySids')
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.changeLoading()
                    return
                }
                this.axios.put(this.urlFormat(API.ACCESS_POLICES_RELATEGROUP, false), this.formData).then(res => {
                    if (res.status) {
                        this.$emit('refresh')
                        this.show = false
                    } else {
                        this.changeLoading()
                    }
                }).catch(() => {
                    this.changeLoading()
                })
            })
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.$refs.form.resetFields()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.config-pack {
    padding-right: 40px;
}
</style>
<style lang="less">
.config-pack {
    .ivu-transfer-list-content-item {
        display: flex;
        align-items: center;
        padding: 4px 12px;
        & > span {
            span {
                display: block;
            }
            p {
                color: #999;
                font-size: 10px;
            }
        }
    }
    .ivu-input-wrapper-small .ivu-input-icon {
        height: 24px !important;
        line-height: 24px !important;
    }
}
</style>
